import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tableFileSize',
    standalone: false
})
export class TableFileSizePipe implements PipeTransform {
  transform(bytes: number | string | null | undefined): string {
    if (bytes === null || bytes === undefined || bytes === '') {
      return '0 B';
    }

    // Convert to number if it's a string
    const numBytes = typeof bytes === 'string' ? parseInt(bytes, 10) : bytes;

    if (isNaN(numBytes) || numBytes < 0) {
      return '0 B';
    }

    if (numBytes === 0) {
      return '0 B';
    }

    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const i = Math.floor(Math.log(numBytes) / Math.log(k));

    return parseFloat((numBytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
